module.exports = "/assets/data/ac9144a78a8330f212256860ac2326d6-TS14.data.json";